'use client'

import { Heart16, Heart24, HeartFilled16, HeartFilled24 } from '@vinted/monochrome-icons'
import { Animation, Icon } from '@vinted/web-ui'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useAsset } from '@marketplace-web/shared/assets'

type Props = {
  isFavourite: boolean
  isToggled: boolean
  isIconLarge?: boolean
}

const HeartIcon = ({ isFavourite, isToggled, isIconLarge }: Props) => {
  const asset = useAsset('/assets/animations')
  const isPrideFavouriteButtonEnabled = useFeatureSwitch('pride_favourite_button')

  const showPrideHeart = isPrideFavouriteButtonEnabled && isFavourite && isToggled

  const getIconName = () => {
    if (isIconLarge) {
      return isFavourite ? HeartFilled24 : Heart24
    }

    return isFavourite ? HeartFilled16 : Heart16
  }

  if (showPrideHeart) {
    return (
      <Animation
        size={Animation.Size.Small}
        animationUrl={asset('pride-heart.json')}
        aria={{ 'aria-hidden': 'true' }}
        loop={false}
      />
    )
  }

  return (
    <Icon
      name={getIconName()}
      color={isFavourite ? 'warning-default' : 'parent'}
      aria={{ 'aria-hidden': 'true' }}
    />
  )
}

export default HeartIcon
